import { useMemo } from 'react';
import NsProductCard from '@britishgasenergy/react-nucleus/dist/nuc-components/NsProductCard';
import NsSkeleton from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSkeleton';

export const testId = 'tariffCardsSkeletonTestId';

export const TariffCardSkeleton = () => {
  return useMemo(
    () => (
      <NsProductCard role="listitem" type="horizontal">
        <h2 slot="name">
          <NsSkeleton />
        </h2>

        <p slot="price-heading">
          <NsSkeleton />
        </p>

        <h1 slot="price">
          <NsSkeleton />
        </h1>

        <div slot="description">
          <p slot="paragraph">
            <NsSkeleton type="paragraph" />
          </p>
          <br />
          <p>
            <NsSkeleton />
          </p>
          <p>
            <NsSkeleton />
          </p>
        </div>

        <div slot="cta">
          <h1 slot="heading">
            <NsSkeleton type="heading" />
          </h1>
        </div>
      </NsProductCard>
    ),
    []
  );
};

type TariffCardsSkeletonProps = {
  Wrapper: React.ElementType;
};

export const TariffCardsSkeleton = ({ Wrapper }: TariffCardsSkeletonProps) => {
  return useMemo(
    () => (
      <Wrapper testId={testId}>
        <TariffCardSkeleton />
        <TariffCardSkeleton />
      </Wrapper>
    ),
    [Wrapper]
  );
};
